/**
 * `rel` for same-origin links that open a new tab (portal to docs and back).
 *
 * `target="_blank"` implies `noopener`, and a tab created with `noopener` does
 * not receive a copy of the opener's `sessionStorage`. Logins without
 * "Remember me" live in `sessionStorage` (AES-303), so the new tab would land
 * on the login form. `opener` restores the copy.
 *
 * Keep `noopener noreferrer` on links that leave this origin.
 */
export const SAME_ORIGIN_NEW_TAB_REL = "opener";
